<app-top-nav [expand]="expand"></app-top-nav>
<div class="content">
  <!--  <app-side-nav class="side-nav"></app-side-nav>-->
  <app-left-menu [class.expand]="expand" [expand]="expand" (expandEvent)="expandMenu($event)"></app-left-menu>
  <main class="main">
    <router-outlet></router-outlet>
  </main>
</div>
